// Translation dictionary - Admin can edit these values
// To edit: Simply change the Burmese (my) text values below

export type Language = 'en' | 'my';

export const translations = {
  // Header
  'app.name': { en: 'SheCare', my: 'SheCare' },
  'header.staffLogin': { en: 'Staff Login', my: 'ဝန်ထမ်းဝင်ရောက်ရန်' },

  // Hero Section
  'hero.badge': { en: 'Specialists available now', my: 'Specialist ထိုင်နေပါသည်' },
  'hero.title1': { en: "Women's Health Made Simple", my: 'အမျိုးသမီးကျန်းမာရေး စောင့်ရှောက်မှု' },
  'hero.subtitle': {
    en: 'Connect with qualified healthcare professionals from the comfort of your home. Private, secure, and convenient consultations.',
    my: 'အရည်အချင်းပြည့်မီသော ကျန်းမာရေးပညာရှင်များနှင့် လွယ်လင့်တကူ ချိတ်ဆက်နိုင်ပါပြီ။'
  },
  'hero.bookConsultation': { en: 'Book Consultation', my: 'ဘွတ်ကင်လုပ်ပါ' },

  // Trust Indicators
  'trust.licensed': { en: 'Licensed Professionals', my: 'လိုင်စင်ရ ပညာရှင်များ' },
  'trust.confidential': { en: '100% Confidential', my: '၁၀၀% လျှို့ဝှက်' },
  'trust.secure': { en: 'Secure Platform', my: 'လုံခြုံသော ပလက်ဖောင်း' },

  // Features Section
  'features.title': { en: 'Why Choose SheCare?', my: 'SheCare ကို ဘာကြောင့် ရွေးချယ်သင့်သလဲ?' },
  'features.subtitle': {
    en: "We're committed to providing accessible, compassionate healthcare for women.",
    my: 'အမျိုးသမီးများအတွက် စာနာတတ်သော ကျန်းမာရေးစောင့်ရှောက်မှုကို ပေးအပ်ပါသည်။'
  },
  'features.quickAccess.title': { en: 'Quick Access', my: 'မြန်ဆန်စွာ ရယူနိုင်' },
  'features.quickAccess.desc': {
    en: 'Get connected with a healthcare professional quickly. No long waiting times or complicated booking processes.',
    my: 'ကျန်းမာရေးပညာရှင်နှင့် မြန်ဆန်စွာ ချိတ်ဆက်ပါ။'
  },
  'features.trustedExperts.title': { en: 'Trusted Experts', my: 'ယုံကြည်ရသော ကျွမ်းကျင်သူများ' },
  'features.trustedExperts.desc': {
    en: "All our healthcare professionals are licensed and experienced in women's health. Your care is in good hands.",
    my: 'ကျန်းမာရေးပညာရှင်များအားလုံးသည် လိုင်စင်ရပြီး အတွေ့အကြုံရှိသူများဖြစ်သည်။'
  },
  'features.privateSecure.title': { en: 'Private & Secure', my: 'သီးသန့်နှင့် လုံခြုံသော' },
  'features.privateSecure.desc': {
    en: 'Your health information stays confidential. We use secure, encrypted communication for all consultations.',
    my: 'သင့်ကျန်းမာရေးအချက်အလက်များကို လျှို့ဝှက်ထားပါသည်။'
  },

  // CTA Section
  'cta.title': { en: 'Ready to Get Started?', my: 'စတင်ရန် အဆင်သင့်ဖြစ်ပြီလား?' },
  'cta.subtitle': {
    en: 'Book your consultation today and take the first step towards better health.',
    my: 'ယနေ့ ဘွတ်ကင်လုပ်ပြီး ကျန်းမာရေးဆီသို့ ပထမခြေလှမ်းကို လှမ်းလိုက်ပါ။'
  },
  'cta.bookNow': { en: 'Book Now — $19.99', my: 'ယခုဘွတ်ကင်လုပ်ပါ — $19.99' },

  // Footer
  'footer.copyright': { en: '© 2026 SheCare. All rights reserved.', my: '© 2026 SheCare' },
  'footer.admin': { en: 'Admin', my: 'အက်ဒမင်' },
  'footer.privacy': { en: 'Privacy', my: 'Privacy' },
  'footer.terms': { en: 'Terms', my: 'Terms' },

  // Modal
  'modal.title': { en: 'Book Consultation', my: 'ဘွတ်ကင်လုပ်ပါ' },
  'modal.step': { en: 'Step', my: 'အဆင့်' },
  'modal.of': { en: 'of', my: '/' },

  // Step 1
  'step1.title': { en: 'What would you like to discuss?', my: 'ဘာကို ဆွေးနွေးလိုပါသလဲ?' },
  'step1.subtitle': { en: 'Select all that apply', my: 'သက်ဆိုင်သမျှကို ရွေးချယ်ပါ' },
  'step1.continue': { en: 'Continue', my: 'ဆက်လက်ရန်' },

  // Symptoms
  'symptom.irregularCycles': { en: 'Irregular Cycles', my: 'ရာသီ မမှန်' },
  'symptom.heavyBleeding': { en: 'Heavy Bleeding', my: 'သွေးများခြင်း' },
  'symptom.painfulPeriods': { en: 'Painful Periods', my: 'ရာသီလာချိန်တွင် နာကျင်' },
  'symptom.pcosSymptoms': { en: 'PCOS Symptoms', my: 'PCOS' },
  'symptom.fertilityConcerns': { en: 'Fertility Concerns', my: 'သားဆက်ပြဿနာ' },
  'symptom.hormonalImbalance': { en: 'Hormonal Imbalance', my: 'ဟော်မုန်းမမျှတ' },
  'symptom.fatigue': { en: 'Fatigue', my: 'ပင်ပန်းခြင်း' },
  'symptom.moodChanges': { en: 'Mood Changes', my: 'စိတ်ပြောင်းလဲခြင်း' },
  'symptom.weightChanges': { en: 'Weight Changes', my: 'အလေးချိန်ပြောင်း' },
  'symptom.acne': { en: 'Acne', my: 'ဝက်ခြံ' },
  'symptom.hairLoss': { en: 'Hair Loss', my: 'ဆံပင်ကျွတ်' },
  'symptom.sleepIssues': { en: 'Sleep Issues', my: 'အိပ်မပျော်' },
  'symptom.anxiety': { en: 'Anxiety', my: 'စိုးရိမ်ခြင်း' },
  'symptom.depression': { en: 'Depression', my: 'စိတ်ကျခြင်း' },
  'symptom.other': { en: 'Other', my: 'အခြား' },

  // Step 2
  'step2.title': { en: 'Your Details', my: 'သင့်အချက်အလက်များ' },
  'step2.subtitle': { en: "We'll send your consultation invite here", my: 'ဖိတ်ကြားစာကို ဤနေရာသို့ ပို့ပေးပါမည်' },
  'form.fullName': { en: 'Full Name', my: 'အမည်အပြည့်အစုံ' },
  'form.fullNamePlaceholder': { en: 'Enter your full name', my: 'အမည် ထည့်ပါ' },
  'form.email': { en: 'Email Address', my: 'အီးမေးလ်' },
  'form.emailPlaceholder': { en: 'your@email.com', my: 'your@email.com' },
  'form.emailNote': { en: 'Meeting invite will be sent to this email', my: 'ဖိတ်ကြားစာကို ဤအီးမေးလ်သို့ ပို့ပေးပါမည်' },
  'form.phone': { en: 'Phone Number', my: 'ဖုန်းနံပါတ်' },
  'form.optional': { en: '(Optional)', my: '(မဖြစ်မနေမဟုတ်)' },
  'form.phonePlaceholder': { en: 'Phone number', my: 'ဖုန်းနံပါတ်' },
  'form.age': { en: 'Age', my: 'အသက်' },
  'form.agePlaceholder': { en: 'Age', my: 'အသက်' },
  'form.gender': { en: 'Gender', my: 'ကျား/မ' },
  'form.female': { en: 'Female', my: 'အမျိုးသမီး' },
  'form.male': { en: 'Male', my: 'အမျိုးသား' },
  'form.other': { en: 'Other', my: 'အခြား' },
  'form.preferNotToSay': { en: 'Prefer not to say', my: 'မပြောလိုပါ' },
  'form.preferredDate': { en: 'Preferred Date', my: 'ရက်စွဲ' },
  'form.preferredTime': { en: 'Preferred Time', my: 'အချိန်' },
  'form.officeHours': { en: 'Office Hours', my: 'ရုံးချိန်' },
  'form.officeHoursTime': { en: '9:00 AM - 5:00 PM', my: '၉:၀၀ - ၅:၀၀' },
  'form.afterHours': { en: 'After Hours', my: 'ရုံးချိန်ပြင်ပ' },
  'form.afterHoursTime': { en: '5:00 PM - 10:00 PM', my: '၅:၀၀ - ၁၀:၀၀' },
  'form.back': { en: 'Back', my: 'နောက်သို့' },

  // Step 3
  'step3.title': { en: 'Additional Information', my: 'နောက်ထပ် အချက်အလက်များ' },
  'step3.subtitle': { en: 'Help us prepare for your consultation', my: 'ပြင်ဆင်ရန် ကူညီပါ' },
  'form.medicalHistory': { en: 'Medical History', my: 'ဆေးဘက်ဆိုင်ရာ မှတ်တမ်း' },
  'form.medicalHistoryPlaceholder': { en: 'Any relevant medical conditions...', my: 'ရောဂါများ၊ ဓာတ်မတည့်မှုများ...' },
  'form.currentMedications': { en: 'Current Medications', my: 'လက်ရှိ ဆေးများ' },
  'form.currentMedicationsPlaceholder': { en: 'List any medications...', my: 'ဆေးများကို စာရင်းပြုပါ...' },
  'form.medicalCertificate': { en: 'Medical Certificate', my: 'ဆေးလက်မှတ်' },
  'form.medicalCertificateNote': { en: 'I may need an MC for work/school', my: 'ဆေးလက်မှတ် လိုအပ်နိုင်သည်' },
  'form.additionalNotes': { en: 'Additional Notes', my: 'မှတ်ချက်များ' },
  'form.additionalNotesPlaceholder': { en: "Anything else you'd like us to know...", my: 'အခြားအရာများ...' },
  'form.continueToPayment': { en: 'Continue to Payment', my: 'ငွေပေးချေမှုသို့' },
  'form.processing': { en: 'Processing...', my: 'လုပ်ဆောင်နေသည်...' },

  // Step 4
  'step4.title': { en: 'Complete Payment', my: 'ငွေပေးချေမှု' },
  'step4.subtitle': { en: 'Secure your consultation appointment', my: 'ချိန်းဆိုချက်ကို အတည်ပြုပါ' },

  // Errors
  'error.selectSymptom': { en: 'Please select at least one symptom', my: 'လက္ခဏာတစ်ခု ရွေးချယ်ပါ' },
  'error.nameRequired': { en: 'Name is required', my: 'အမည် လိုအပ်ပါသည်' },
  'error.emailRequired': { en: 'Email address is required', my: 'အီးမေးလ် လိုအပ်ပါသည်' },
  'error.emailInvalid': { en: 'Please enter a valid email address', my: 'မှန်ကန်သော အီးမေးလ် ထည့်ပါ' },
  'error.dateRequired': { en: 'Preferred date is required', my: 'ရက်စွဲ လိုအပ်ပါသည်' },
  'error.timeRequired': { en: 'Please select your preferred time', my: 'အချိန် ရွေးချယ်ပါ' },
  'error.ageInvalid': { en: 'Please enter a valid age', my: 'မှန်ကန်သော အသက် ထည့်ပါ' },
  'error.phoneInvalid': { en: 'Invalid phone number', my: 'ဖုန်းနံပါတ် မမှန်ကန်ပါ' },

  // Language
  'language.english': { en: 'English', my: 'English' },
  'language.burmese': { en: 'Myanmar', my: 'မြန်မာ' },
};

export type TranslationKey = keyof typeof translations;

export const t = (key: TranslationKey, lang: Language): string => {
  const translation = translations[key];
  if (!translation) {
    console.warn(`Translation missing for key: ${key}`);
    return key;
  }
  return translation[lang] || translation.en;
};
